import React, { useMemo } from 'react';
import { TooltipWrapper } from '@tcc/crate';
import { ProgramTag } from '@tcc/plugin-ui';
import { ComponentColor, ComponentDensity, ComponentSize, Tag } from '@tcc/fds';
import { getMessage } from 'util/locale';
import { isPrescriptionsProgramTagEnabled } from 'user/selectors';
import { useAppSelector } from 'app/hooks';
import { isWithinHours } from 'util/dates';
import { useProgramInstance } from './hooks/useProgramInstance';

interface PrescriptionsFlagsProps {
  createdAt?: string;
  isPrimary?: boolean;
  programInstanceId?: string;
}

const PrescriptionsFlags = ({
  createdAt,
  isPrimary,
  programInstanceId
}: PrescriptionsFlagsProps) => {
  const isPrescriptionsProgramTag = useAppSelector(isPrescriptionsProgramTagEnabled);
  const { programInstanceData } = useProgramInstance(programInstanceId);
  const { name: programName, iconUrl } = programInstanceData?.program || {};
  const showProgramTag = isPrescriptionsProgramTag && programName;
  const isNew = useMemo(() => isWithinHours(createdAt, 48), [createdAt]);

  if (!isPrimary && !showProgramTag && !isNew) return null;

  return (
    <div className="vra-prescription-flags">
      {isPrimary && (
        <TooltipWrapper
          placement="bottom"
          testId="primary-flag-tooltip-text"
          content={[getMessage('tooltip-text__primary-flag')]}
        >
          <Tag testId="primary-flag" backgroundColor="#ffffff">
            {getMessage('label-text__primary-flag')}
          </Tag>
        </TooltipWrapper>
      )}
      {(showProgramTag && programName) && <ProgramTag program={programName} url={iconUrl} />}
      {isNew && (
        <Tag
          fill="soft"
          size={ComponentSize.Sm}
          color={ComponentColor.Primary}
          density={ComponentDensity.Micro}
          sides="roundedRect"
          testId="prescription-new-label"
        >
          {getMessage('new')}
        </Tag>
      )}
    </div>
  );
};

export default PrescriptionsFlags;
